import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('check', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: props.colors[0],
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: "0",
    x: "0",
    y: "0",
    width: "128",
    height: "128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.40678,40.2949153 L54.9322034,96.7694915 C52.2745763,99.4271186 48.2881356,99.4271186 45.6305085,96.7694915 L17.3932203,68.5322034 C14.7355932,65.8745763 14.7355932,61.8881356 17.3932203,59.2305085 C20.0508475,56.5728814 24.9283991,59.3237063 27.5860262,61.9813334 L51.1724669,85.5677741 L102.996196,33.7440452 C105.653823,31.0864181 108.749153,28.3355932 111.40678,30.9932203 C114.064407,33.6508475 114.064407,37.6372881 111.40678,40.2949153 Z"
  }))));
});